'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeSankeyIcon = function TraceTypeSankeyIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { d: 'M9 20c.68-.038 1.36-.062 2.04-.065l.51-.002c.118 0 .093-.003.106-.004h.023a.225.225 0 0 1 .096 0 3.276 3.276 0 0 0 .436-.003c.245-.1-.029.275 1.324-1.046l2.965-2.813 3.328-3.172a18.619 18.619 0 0 1 9.888-4.556q.907-.126 1.821-.16l1.384-.016c1.36.002 2.72-.006 4.08-.083v16c-1.36-.076-2.72-.085-4.08-.083l-.51-.002c-.115.003-.093.011-.146.011-.07.01-.14.022-.208.037a1.784 1.784 0 0 0-.385.161 1.838 1.838 0 0 0-.555.568c-.02.023-.029.058-.047.082l-.266.322-.647.791-1.296 1.581-2.587 3.164a21.69 21.69 0 0 1-1.732 1.97 18.844 18.844 0 0 1-2.987 2.418 18.143 18.143 0 0 1-7.18 2.76 15.55 15.55 0 0 1-1.935.19l-.89.017-.51-.002c-.68-.003-1.36-.027-2.04-.065z', fill: '#25fdfc' }),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M9 20v18M9 8v10M37 8v30', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { d: 'M9 13.08h1.35a10 10 0 0 1 8.566 4.84l6.169 10.24A10 10 0 0 0 33.65 33H37', fill: 'none', stroke: '#1d9bfb', opacity: '.5', strokeMiterlimit: '10', strokeWidth: '10' }),
        _react2.default.createElement('path', { d: 'M10 9.04h.002a14.77 14.77 0 0 1 12.37 6.698l7.444 11.408a4 4 0 0 0 3.35 1.814H36', fill: 'none', stroke: '#1d9bfb', strokeMiterlimit: '10', strokeWidth: '2' })
    );
};

exports.default = TraceTypeSankeyIcon;